import type { CSSProperties, DetailedHTMLProps, ElementType, ImgHTMLAttributes } from 'react';
import Styles from './image-wrapper.module.scss';
interface ImageWrapperProps {
  component: ElementType<DetailedHTMLProps<ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement>>;
  imgSrc: string;
  imgWidth: CSSProperties['width'];
  imgHeight: CSSProperties['height'];
  alt?: string;
  testId?: string;
}

interface ImageComponentWrapperProps {
  imgWidth?: CSSProperties['width'];
  imgHeight?: CSSProperties['height'];
}

export function ImageWrapper({
  component: Component,
  imgSrc,
  imgWidth = '100%',
  imgHeight = 'auto',
  alt,
  testId,
}: ImageWrapperProps) {
  return (
    <div className={Styles.ImageWrapper} style={{ width: imgWidth, height: imgHeight }}>
      <Component src={imgSrc} width={imgWidth} height={imgHeight} alt={alt} data-testid={testId} />
    </div>
  );
}
